import dayjs from "dayjs";
import { ActivityDetailData } from "../../../pages/logbook/pages/main/components/shared/detail/types";
import { ActivityDetail } from "../response";
import { Constants } from "../../../utils/constants";
import { listRoles } from "../../roles";
import { getLocalStorage } from "../../../utils/crud/crypt";
import { Roles, Status } from "../../../utils/enums";
import { formatGeneralEvidenceConfig } from "../../../components/uploadEvidence/methods";
import { StoreType } from "../../../pages/logbook/pages/main/utils/enums/storeType";
import { ActivityType } from "../../../pages/logbook/pages/main/utils/enums/activityType";

export const formatActivityDetail = ({ response }: { response: ActivityDetail }) => {
    const state = getLocalStorage<any>()
    const assignedUser = response?.user
    const userManage = response?.userManage
    const isTheUserAssigned = response?.user?.id == state.id || state.role == Roles.ADMIN
    //const isUserWithPermission = [assignedUser?.id, userManage?.id].some(userId => userId == state.id) || state.role == Roles.ADMIN
    const isUserWithPermission = [assignedUser?.id].some(userId => userId == state.id) || response.canDoActions || state.role == Roles.ADMIN
    let storePoint = { lat: 0, lng: 0, locationInitSiteName: '' }
    const coordinates: unknown[] = [];
    let storeCoordinates: { lat?: number; lng?: number; storeName?:string; storeType?: StoreType, status?:Status} | undefined = undefined;
    const detail = {
        title: response.title,
        startDate: response.dateStartExecution ? dayjs.utc(response.dateStartExecution).format(Constants.dateFormatDateTimePicker) : '',
        endDate: response.dateEndExecution ?  dayjs.utc(response.dateEndExecution).format(Constants.dateFormatDateTimePicker) : '',
        startProgramed: response.dateStart ? dayjs.utc(response.dateStart).format(Constants.dateFormatDateTimePicker) : '',
        endProgramed: response.dateEnd ? dayjs.utc(response.dateEnd).format(Constants.dateFormatDateTimePicker) : '' ,
        status: response.statusId,
        userName: `${assignedUser?.firstName} ${assignedUser?.lastName}`,
        isFree: response.geofence ? ActivityType.AUTOMATIC : !response.dateEnd && !response.dateStart ? ActivityType.FREE : ActivityType.PROGRAMMED
    }
    if (response.locationInitActivity) {
        const [latInit, lngInit] = response.locationInitActivity.split(',').map(Number);
        storePoint = { lat: latInit, lng: lngInit, locationInitSiteName: response.locationInitSiteName ?? '' }
        coordinates.push({
            lat: latInit,
            lng: lngInit,
            extraData:`1 Inic`,
            label: 'Inicio de la actividad',
            ...detail
        });
    }

    if (response.locationFinishActivity) {
        const [latFinish, lngFinish] = response.locationFinishActivity.split(',').map(Number);
        coordinates.push({
            lat: latFinish,
            lng: lngFinish,
            extraData:`1 Fin`,
            label: 'Fin de la actividad',
            ...detail
        });
    }

    if (response.locationInitSite) {
        const [latFinish, lngFinish] = response.locationInitSite.split(',').map(Number);
        storeCoordinates = {
            lat: latFinish,
            lng: lngFinish,
            storeName:  response.locationInitSiteName ?? '',
            storeType: StoreType.DESTINATION,
            status: response.statusId
        };
    }

    if (response.storeInit) {
        //const [latFinish, lngFinish] = response.storeInit.split(',').map(Number);
        storeCoordinates = {
            lat: Number(response.storeInit.latitude),
            lng: Number(response.storeInit.longitude),
            storeName:  `${response.storeInit.keyCode} - ${response.storeInit.name}`,
            storeType: StoreType.UNITY,
            status: response.statusId
        };
    }

    return {
        data: response,
        transform: {
            assignedUser: {
                areas: assignedUser?.userDepartments?.map(area => area.name),
                departments: assignedUser?.userDepartments?.flatMap(area => area.departaments?.map(department => department.name)),
                division: assignedUser?.division?.description,
                fullName: `${assignedUser?.firstName ?? ''} ${assignedUser?.lastName ?? ''}`.trim(),
                role: listRoles.find(role => assignedUser?.roleId == role.id)?.description
            },
            description: {
                activityType: response.typeActivity?.title,
                assignedBy: `${userManage?.firstName ?? ''} ${userManage?.lastName ?? ''}`.trim(),
                closingActivityDate: response.updateTime ? dayjs.utc(response.updateTime).format(Constants.dateFormatDateTimePicker) : '',
                closingStore: response?.storeFinish ? `${response?.storeFinish?.keyCode} - ${response?.storeFinish?.name}` : response.locationFinishSiteName,
                destination: response?.storeInit ? `${response?.storeInit?.keyCode} - ${response?.storeInit?.name}` : response.locationInitSiteName,
                initLocation:response.locationInitActivity,
                finishLocation:response.locationFinishActivity,
                endDate: response.dateEnd ? dayjs.utc(response.dateEnd).format(Constants.dateFormatDateTimePicker) : '',
                startDate: response.dateStart ? dayjs.utc(response.dateStart).format(Constants.dateFormatDateTimePicker) : '',
                closingComment: response.closeMotive ?? '',
                observation: response.description ?? '',
                activityTypeText: response.activityTypeText ?? '',
                status: response.statusId,
                typeActrivity:response.geofence ? ActivityType.AUTOMATIC : !response.dateEnd && !response.dateStart ? ActivityType.FREE : ActivityType.PROGRAMMED,
                dateStartExecution: response.dateStartExecution ? dayjs.utc(response.dateStartExecution).format(Constants.dateFormatDateTimePicker) : undefined,
                dateEndExecution: response.dateEndExecution ? dayjs.utc(response.dateEndExecution).format(Constants.dateFormatDateTimePicker) : undefined
            },
            header: {
                isforcedClosure: !!response.forceClose,
                status: response.statusId,
                title: response.title
            },
            mark: [
                {
                    color: '#cc00ff',
                    user: {

                    },
                    points: coordinates,
                    storeLocation: storeCoordinates
                }
            ],
            geofence: !!response?.geofence,
            storeInitId: response?.storeInitId?.toString(),
            evidence: response.evidences,
            isUserWithPermission,
            isTheUserAssigned,
            generalConfig: formatGeneralEvidenceConfig({ config: response.currentTypeActivity?.configEvidences, evidences: response.evidences }),
            startDate: response.dateStart ? dayjs.utc(response.dateStart) : null,
            endDate: response.dateEnd ? dayjs.utc(response.dateEnd) : null,
            timeZone: response.storeInit?.storeTimeZone ?? Constants.defaultTimeZoneObject,
            storePoint: storePoint
            //...!!response.locationInitSite && { storePoint: storePoint }
        } as ActivityDetailData
    }
}